import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { User, AuthService, AuthType, TranslateService, TohumUiModule } from '@anadolu-commons/tohum-ui';
import { HttpHeaders, HttpXsrfTokenExtractor, HttpClient } from '@angular/common/http';

@Component({
    selector: 'aof-user-panel',
    standalone: true,
    imports: [TohumUiModule],
    templateUrl: './user-panel.component.html',
    styleUrls: ['./user-panel.component.scss']
})
export class UserPanelComponent implements OnInit {
    user: User;
    authenticated: boolean;

    authTypes: AuthType[];

    langs: string[];
    selectedLangIndex: number;

    @HostBinding('class')
    readonly className = 'thm-user-panel';

    constructor(private authService: AuthService, private router: Router,
                @Inject(DOCUMENT) private document: any, private translateService: TranslateService, 
                private http: HttpClient, private tokenExtractor: HttpXsrfTokenExtractor) {
    }

    ngOnInit() {
        this.user = this.authService.getUser();
        this.authenticated = this.authService.isAuthenticated();

        this.authTypes = [];
        for (const type in this.authService.authTypes) {
            if (this.authService.authTypes.hasOwnProperty(type)) {
                this.authTypes.push(type as AuthType);
            }
        }

        this.langs = this.translateService.getLangs();
        this.langs.forEach((lang, index) => {
            if (lang === this.translateService.getLang()) {
                this.selectedLangIndex = index;
            }
        });
    }

    login(type: AuthType) {

        const token = this.tokenExtractor.getToken() as string;
        let headers = new HttpHeaders();
        if (token !== null) {
          headers = headers.append('X-XSRF-TOKEN', token);
        }
        this.http.get<any>('/auth/oauth/authorize', { headers }).subscribe(result => {
          this.document.location.href = result.data.redirectUrl;
        });

        //const target = this.router.url;
        //this.document.location.href = this.authService.getLoginUrl(type, target);
    }

    logout() {

        const token = this.tokenExtractor.getToken() as string;
        let headers = new HttpHeaders();
        if (token !== null) {
          headers = headers.append('X-XSRF-TOKEN', token);
        }
        this.http.get<any>('/auth/oauth/logout', { headers }).subscribe(result => {
          this.document.location.href = result.data.redirectUrl;
        });

        //this.authService.logout().subscribe(json => {
        //   this.document.location.href = '/';
        //});
    }

    onSelectedLangChange(index: number) {
        this.selectedLangIndex = index;
        const lang = this.langs[index];
        this.translateService.setLang(lang);
    }
}
